import { Navigate } from 'react-router-dom'
import { ROUTES } from '@/config/routes'

const WebRoute = ({ children }: { children: JSX.Element }) => {
  const domain = window.location.hostname

  if (domain.includes('localhost')) {
    return children
  }

  // se o domínio não começar com "web." → redireciona para "/"
  if (!domain.startsWith('web.') && !domain.startsWith('dev.')) {
    return <Navigate to={ROUTES.HOME.path} replace />
  }

  return children
}

export default WebRoute
